import { GET_VERSOES_PBI_INIT, GET_VERSOES_PBI_SUCCESS, UPDATE_STATUS_VERSAO_PBI_INIT, UPDATE_STATUS_VERSAO_PBI_SUCCESS, ERROR_DEFINICOES_PBI_MSG, CLEAR_FLAGS_DEFINICOES_PBI } from '../actionTypes';
import { IVersaoPbi } from 'src/integracoes/servicos/mongo-atlas/modelos/IDefinicoesPbi';

const INIT_STATE = {
  versoesPbi: [] as IVersaoPbi[],
  loading: false,
  isSuccess: false,
  isError: false,
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case GET_VERSOES_PBI_INIT:
      return { ...state, loading: true };
    case GET_VERSOES_PBI_SUCCESS: {
      const { versoesPbi } = action.payload;
      return { ...state, loading: false, versoesPbi };
    }
    case UPDATE_STATUS_VERSAO_PBI_INIT:
      return { ...state, loading: true, isSuccess: false, isError: false, msg: '' };
    case UPDATE_STATUS_VERSAO_PBI_SUCCESS: {
      const { versao, statusVersao } = action.payload;
      const versoesPbi = state.versoesPbi.map((v) =>
        v.versao === versao ? { ...v, statusVersao } : v
      );
      return { ...state, loading: false, isSuccess: true, versoesPbi };
    }
    case ERROR_DEFINICOES_PBI_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, isError: true, msg };
    }
    case CLEAR_FLAGS_DEFINICOES_PBI:
      return { ...state, loading: false, isSuccess: false, isError: false, msg: '' };
    default:
      return { ...state };
  }
};
